(() => {
  if (customElements.get('sprzelook-details')) return;

  const formatMeasurement = (raw, unit) => {
    raw = String(raw).trim();
    if (!raw) return null;

    const suffix = unit === 'in' ? ' in' : ' mm';
    const formatNumber = number =>
      unit === 'in'
        ? (number / 25.4).toFixed(2)
        : String(number);

    // 单尺码，例如 56 或 50.5
    if (/^\d+(?:\.\d+)?$/.test(raw)) {
      const number = Number(raw);

      return Number.isFinite(number)
        ? formatNumber(number) + suffix
        : null;
    }

    // 多尺码，例如 M:50 / L:53
    const pattern = /([A-Za-z0-9]+)\s*:\s*(\d+(?:\.\d+)?)/g;
    const pairs = [...raw.matchAll(pattern)];
    const residue = raw
      .replace(pattern, '')
      .replace(/[\s/;]+/g, '');

    if (!pairs.length || residue) return null;

    return pairs
      .map(pair =>
        pair[1].toUpperCase() +
        ':' +
        formatNumber(Number(pair[2]))
      )
      .join(' / ') + suffix;
  };

  customElements.define(
    'sprzelook-details',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const tabs = [...this.querySelectorAll('[role="tab"]')];

        const select = tab => {
          tabs.forEach(item => {
            const active = item === tab;

            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;

            this.querySelector(
              '#' + CSS.escape(item.getAttribute('aria-controls'))
            ).hidden = !active;
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));

          tab.addEventListener('keydown', event => {
            let next;

            if (event.key === 'ArrowRight') {
              next = (index + 1) % tabs.length;
            }

            if (event.key === 'ArrowLeft') {
              next = (index + tabs.length - 1) % tabs.length;
            }

            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;

            if (next !== undefined) {
              event.preventDefault();
              select(tabs[next]);
              tabs[next].focus();
            }
          });
        });

        this.querySelectorAll('[data-unit]').forEach(button => {
          button.addEventListener('click', () => {
            const unit = button.dataset.unit;

            this.querySelectorAll('[data-unit]').forEach(item => {
              item.setAttribute(
                'aria-pressed',
                String(item === button)
              );
            });

            this.querySelectorAll('[data-mm]').forEach(element => {
              const text = formatMeasurement(
                element.dataset.mm,
                unit
              );

              if (text !== null) {
                element.textContent = text;
              }
            });
          });
        });
      }
    }
  );
})();